import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_ConfirmationModal } from '../../../../../../../../design/modals/confirmationModal/S_ConfirmationModal';

interface IProps {
  show: boolean;
  onHide: () => void;
  onSubmit: () => Promise<void>;
}

export const InformationStepModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { show, onHide, onSubmit } = props;

  return (
    <S_ConfirmationModal
      cancelText={t('new.projects.details.import_annotations.cancel')}
      headerText={`${t('new.projects.details.import_annotations.header')} - ${t('new.projects.details.import_annotations.steps.information.header')}`}
      submitText={t('new.projects.details.import_annotations.next')}
      onCancel={onHide}
      toggle={onHide}
      onSubmit={onSubmit}
      isOpen={show}
    >
      <p>{t('new.projects.details.import_annotations.steps.information.body')}</p>
    </S_ConfirmationModal>
  );
});
